export enum WebAppType {
    ORGANITZ = 'Organitz',
    ACCOUNTITZ = 'Accountitz'
}

export interface UserActiveCounter {
    clientId: number,
    clientName: string,
    counter: number
}

export interface ClientDomain {
    id: number,
    name: string,
    domain: string,
    webapp?: string
}

export interface ClientDomainUpdate {
    name: string,
    domain: string,
    webapp: string
}
